import { ReqBodyWithoutHeaders } from './../../types/state/apiTypes'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { fetchApi } from '../../helpers/Api'

interface OfferBannerType {
	BANNER_IMAGE: string
	BANNER_URL: string
	ANALYTICS_CTA_NAME: string
}

interface OfferObjType {
	VOTES_SUBMITTED: string
	VOTES_CLOSED: string
	CLOSED_SUB_HEADING: string[]
	SUB_HEADING: string[]
	SHOW_OFFERS: boolean
	EXCLUSIVE_OFFER: string[]
	OFFER_BANNER: OfferBannerType[]
	LENSKART_LOGO: string
	EVENT_LOGO: string
	DOWNLOAD_STRIP_LOGO: string
	DOWNLOAD_STRIP_LINK: string
	VOTED_ALREADY: string
	VOTED_ALREADY_SUB_HEADING: string[]
	SCRATCH_CARD: string
	SCRATCH_KBCGOLD: string
	SCRATCH_LK1: string
	SCRATCH_LK2: string
	SCRATCH_BLNT: string
	TIMELINE: string
	SHOW_WINNERS: boolean
	OFFER_BANNER_WON_NOTHING: OfferBannerType[]
	OFFER_BANNER_WON_LK: OfferBannerType[]
	OFFER_BANNER_WON_KBC: OfferBannerType[]
}

const initialState: OfferObjType = {
	VOTES_SUBMITTED: '',
	VOTES_CLOSED: '',
	CLOSED_SUB_HEADING: [],
	SUB_HEADING: [],
	SHOW_OFFERS: false,
	EXCLUSIVE_OFFER: [],
	OFFER_BANNER: [],
	LENSKART_LOGO: '',
	EVENT_LOGO: '',
	DOWNLOAD_STRIP_LOGO: '',
	DOWNLOAD_STRIP_LINK: '',
	VOTED_ALREADY: '',
	VOTED_ALREADY_SUB_HEADING: [],
	SCRATCH_CARD: '',
	SCRATCH_KBCGOLD: '',
	SCRATCH_LK1: '',
	SCRATCH_LK2: '',
	SCRATCH_BLNT: '',
	TIMELINE: '',
	SHOW_WINNERS: false,
	OFFER_BANNER_WON_NOTHING: [],
	OFFER_BANNER_WON_LK: [],
	OFFER_BANNER_WON_KBC: [],
}

export const getOffersJSON = createAsyncThunk(
	'offers/json',
	async (reqObj: ReqBodyWithoutHeaders) => {
		const response = await fetchApi(reqObj)
		return { ...response.result }
	}
)

export const offersSlice = createSlice({
	name: 'offers',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(getOffersJSON.fulfilled, (state, action) => {
			state.VOTES_SUBMITTED = action.payload.VOTES_SUBMITTED
			state.SUB_HEADING = action.payload.SUB_HEADING

			state.VOTES_CLOSED = action.payload.VOTES_CLOSED
			state.CLOSED_SUB_HEADING = action.payload.CLOSED_SUB_HEADING

			state.VOTED_ALREADY = action.payload.VOTED_ALREADY
			state.VOTED_ALREADY_SUB_HEADING =
				action.payload.VOTED_ALREADY_SUB_HEADING

			state.SHOW_OFFERS = action.payload.SHOW_OFFERS
			state.EXCLUSIVE_OFFER = action.payload.EXCLUSIVE_OFFER
			state.OFFER_BANNER = action.payload.OFFER_BANNER
			state.LENSKART_LOGO = action.payload.LENSKART_LOGO
			state.EVENT_LOGO = action.payload.EVENT_LOGO

			state.SCRATCH_CARD = action.payload.SCRATCH_CARD
			state.SCRATCH_BLNT = action.payload.SCRATCH_BLNT
			state.SCRATCH_KBCGOLD = action.payload.SCRATCH_KBCGOLD
			state.SCRATCH_LK1 = action.payload.SCRATCH_LK1
			state.SCRATCH_LK2 = action.payload.SCRATCH_LK2
			// state.TIMELINE = action.payload.TIMELINE
			state.SHOW_WINNERS = action.payload.SHOW_WINNERS

			state.OFFER_BANNER_WON_NOTHING =
				action.payload.OFFER_BANNER_WON_NOTHING
			state.OFFER_BANNER_WON_LK = action.payload.OFFER_BANNER_WON_LK
			state.OFFER_BANNER_WON_KBC = action.payload.OFFER_BANNER_WON_KBC
			// state.DOWNLOAD_STRIP_LINK = action.payload.DOWNLOAD_STRIP.DEEP_LINK
			// state.DOWNLOAD_STRIP_LOGO = action.payload.DOWNLOAD_STRIP.IMG_URL
		})
	},
})

export default offersSlice.reducer
